import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ProblemSolution from './components/ProblemSolution';
import CategoryGrid from './components/CategoryGrid';
import SEOHub from './components/SEOHub';
import ComparisonSection from './components/ComparisonSection';
import FeatureTable from './components/FeatureTable';
import TrustBlock from './components/TrustBlock';
import ArticlesSection from './components/ArticlesSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      name: 'CSSBuy.watch',
      url: 'https://cssbuy.watch',
      description: 'Encontre a melhor lista CSSBuy Spreadsheet atualizada diariamente com produtos verificados, precos baixos e qualidade premium.',
      inLanguage: 'pt-BR',
      publisher: {
        '@type': 'Organization',
        name: 'CSSBuy.watch',
      },
    },
    {
      '@type': 'WebPage',
      name: 'CSSBuy Spreadsheet Atualizado 2026 - A Melhor Lista de Produtos CSSBuy',
      url: 'https://cssbuy.watch',
      description: 'Encontre os melhores CSSBuy Spreadsheets atualizados diariamente com produtos verificados, precos baixos e qualidade premium.',
      isPartOf: { '@id': 'https://cssbuy.watch/#website' },
      about: { '@id': 'https://cssbuy.watch/#organization' },
      inLanguage: 'pt-BR',
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'Inicio',
            item: 'https://cssbuy.watch',
          },
        ],
      },
    },
    {
      '@type': 'Organization',
      '@id': 'https://cssbuy.watch/#organization',
      name: 'CSSBuy.watch',
      url: 'https://cssbuy.watch',
      logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/d367cf6745ee47f3fc82c76d3a54c50c.png',
      description: 'Guia educacional de CSSBuy Spreadsheet com produtos verificados e atualizacoes diarias.',
    },
  ],
};

export default function Home() {
  return (
    <main className="relative min-h-screen">
      <Navbar />
      <HeroSection />
      <ProblemSolution />
      <CategoryGrid />
      <SEOHub />
      <ComparisonSection />
      <FeatureTable />
      <TrustBlock />
      <ArticlesSection />
      <CTASection />
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
    </main>
  );
}